<template>
    <d2-container class="test">
        <div class="my-tabs" style="display: flex; height: 100% !important; justify-content: center">
            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" :style="{ width: tableWidth }">
                <el-tab-pane label="未分配文件" name="wfp">
                    <div>
                        <div style="display: flex">
                            <el-button type="primary" @click="uploadFileDialog = true" size="mini"
                                style="margin-left: 20px; height: 40px">
                                上传材料
                            </el-button>
                            <el-button @click="showCaseList(0)" type="primary" size="mini" style="margin-left: 20px">
                                批量绑定
                            </el-button>
                            <el-button @click="downLoad()" type="primary" size="mini" style="margin-left: 20px">
                                批量下载
                            </el-button>
                            <el-button @click="batchDelete()" type="primary" size="mini" style="margin-left: 20px">
                                批量删除
                            </el-button>
                            <span style="margin-left: 20px; line-height: 40px">
                                表格高度：
                            </span>
                            <el-input style="width: 20%" type="number" v-model="tableHeight" @input="setTableHeight"
                                placeholder="请输入内容"></el-input>
                        </div>

                        <el-table v-loading.body="listLoading" border type="index" :data="list" size="small" stripe
                            :height="tableHeight" row-key highlight-current-row
                            @selection-change="handleSelectionChange"
                            style="width: 100vw; margin-top: 4px; overflow: auto">
                            <el-table-column type="selection" width="55"> </el-table-column>
                            <el-table-column width="80" align="center" label="系统编号">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.id }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column width="300" align="center" label="文件名">
                                <template slot-scope="scope">
                                    <el-link @click="
                                        switchDoc(scope.row.id, scope.row.fileType, scope.$index)
                                        " type="primary">{{ scope.row.fileName }}</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" align="center" label="备注">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.remark }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" align="center" label="上传人">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.userName }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" align="center" label="上传时间">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.createTime }}
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button v-permission:function="['fileInfoManager_bind_btn']" type="danger"
                                        @click="showCaseList(scope.row.id)">
                                        绑定
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="已分配文件" name="yfp">
                    <div>
                        <div style="display: flex">
                            <el-button type="primary" @click="uploadFileDialog = true" size="mini"
                                style="margin-left: 20px; height: 40px">
                                上传材料
                            </el-button>
                            <el-button @click="showCaseList(0)" type="primary" size="mini" style="margin-left: 20px">
                                批量绑定
                            </el-button>
                            <el-button @click="downLoad()" type="primary" size="mini" style="margin-left: 20px">
                                批量下载
                            </el-button>
                            <span style="margin-left: 20px; line-height: 40px">
                                表格高度：
                            </span>
                            <el-input style="width: 20%" type="number" v-model="tableHeight" @input="setTableHeight"
                                placeholder="请输入内容"></el-input>
                        </div>

                        <el-table v-loading.body="listLoading" border type="index" :data="list" size="small" stripe
                            :height="tableHeight" row-key highlight-current-row
                            @selection-change="handleSelectionChange"
                            style="width: 100vw; margin-top: 4px; overflow: auto">
                            <el-table-column type="selection" width="55"> </el-table-column>
                            <el-table-column width="80" align="center" label="系统编号">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.id }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column width="300" align="center" label="文件名">
                                <template slot-scope="scope">
                                    <el-link @click="
                                        switchDoc(scope.row.id, scope.row.fileType, scope.$index)
                                        " type="primary">{{ scope.row.fileName }}</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" align="center" label="备注">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.remark }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" align="center" label="上传人">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.userName }}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" align="center" label="上传时间">
                                <template slot-scope="scope">
                                    <span>
                                        {{ scope.row.createTime }}
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-tab-pane>
            </el-tabs>

            <div style="width: 50%; height: 100%" v-if="showDoc">
                <div style="text-align: right; margin: 10px;">
                    <el-switch v-model="showDoc" active-text="关闭预览" @change="closeDoc" />
                </div>
                <docPage :isValidate="isValidate" :url="url" :id="currentFileId" :currentFileType="currentFileType">
                </docPage>
            </div>
        </div>

        <el-dialog title="案件列表" :close-on-click-modal="false" :visible.sync="caseListShow" width="65%" center>
            <div>
                <div style="display: flex; justify-content: center">
                    <div style="display: flex; height: 48px">
                        <span align="right" style="
                  align: right;
                  display: inline-block;
                  width: 100px;
                  line-height: 48px;
                ">关键字</span>
                        <div style="padding: 8px 0px; width: 350px">
                            <el-input clearable @keyup.enter.native="search()" style="height: 48px; margin-left: 10px"
                                class="filter-item" placeholder="案号，调解号，系统编号，批次号，当事人，卡号" v-model="CaseInfo.keyWord"
                                size="small">
                            </el-input>
                        </div>
                    </div>
                    <div style="display: flex; margin-left: 20px">
                        <el-button type="primary" style="padding: 0px 40px; height: 30px; margin: auto 0"
                            @click.stop="search()" size="small">搜索</el-button>
                        <el-button v-permission:function="['czFileInfoManager_batchBind']" @click="bindCase(0)"
                            type="primary" style="padding: 0px 30px; height: 30px; margin: auto 10px">
                            批量绑定
                        </el-button>
                    </div>
                </div>

                <el-table v-loading.body="listLoading" border type="index" :data="caseList" size="small" stripe
                    :height="tableHeight" row-key highlight-current-row @selection-change="caseHandleSelectionChange"
                    style="width: 100vw; margin-top: 4px; overflow: auto">
                    <el-table-column type="selection" width="55"> </el-table-column>
                    <el-table-column width="80" align="center" label="系统编号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="180" align="center" label="批次号">
                        <template slot-scope="scope">
                            <span> {{ scope.row.batchId }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column width="250" align="center" label="当事人">
                        <template slot-scope="scope">
                            <div>{{ scope.row.plaintiffName }}</div>
                            <span> {{ scope.row.defendantName }} </span>
                        </template>
                    </el-table-column>
                    <el-table-column width="250" align="center" label="案号/调解号">
                        <template slot-scope="scope">
                            <span> {{ scope.row.registerCode }}</span>
                            <span> {{ scope.row.mediationCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="卷宗材料数量">
                        <template v-if="scope.row.czCaseFilesCount > 0" slot-scope="scope">
                            <span>
                                <el-popover placement="right" width="100%" max-height="250" trigger="click">
                                    <el-table :data="caseFilesList" border>
                                        <el-table-column width="100" property="id" label="文件编号"></el-table-column>
                                        <el-table-column width="100" property="documentType"
                                            label="归档类型"></el-table-column>
                                        <el-table-column width="300" property="fileName" label="文件名"></el-table-column>
                                        <el-table-column width="100" property="createTime"
                                            label="上传时间"></el-table-column>
                                        <el-table-column width="100">
                                            <template slot-scope="fileItem">
                                                <el-button @click="previewFile(fileItem.row.id)"
                                                    style="text-align: center;width:100%;" type="text">预览</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <el-button v-if="scope.row.czCaseFilesCount > 0" slot="reference"
                                        @click="getFileList(scope.row.id)">
                                        <el-link type="primary">{{ scope.row.czCaseFilesCount + '件'
                                            }}</el-link></el-button>
                                </el-popover>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="110">
                        <template slot-scope="scope">
                            <el-button v-permission:function="['fileInfoManager_bind']" type="danger"
                                @click="bindCase(scope.row.id)">
                                绑定
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="caseListShow = false">取 消</el-button>
                <el-button type="primary" @click="caseListShow = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="上传材料" :visible.sync="uploadFileDialog" width="30%" center :close-on-click-modal="false">
            <el-form :model="uploadFileModel" label-width="100px" class="demo-CaseForm">
                <el-form-item label="案件材料">
                    <el-upload :show-file-list="showFile" ref="upload" :on-change="fileChange"
                        :action="getFileUploadUrl()" :file-list="fileList" :auto-upload="false"
                        :http-request="HttpUploadFile" multiple :limit="100">
                        <el-button type="primary" @click="uploadFileDialog = true" size="mini"
                            style="margin-left: 20px; height: 40px">
                            上传材料
                        </el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input type="textarea" :rows="12" placeholder="请输入内容" v-model="uploadFileModel.remark">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uploadFileSubmit" type="primary">确定</el-button>
                <el-button @click="uploadFileDialog = false">取 消</el-button>
            </span>
        </el-dialog>
        <template slot="footer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000]" :page-size="limit"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </template>
    </d2-container>
</template>
<script>
import docPage from "@/pages/caseMediate/docPage/docPage";
import { downLoadFile } from "@/plugin/axios";
import { bindCase, getFileInfo,batchDeleteFile } from "@/api/czManager/fileInfo/index";
import { uploadFile } from "@/plugin/axios";
import {
    page,
    previewUrl,
    getCaseUploadFile
} from "@/api/czManager/czCaseInfo/index";
export default {
    components: {
        docPage,
    },
    data() {
        return {
            tableWidth: '100%',
            isWfp: true,
            status: 1,
            activeName: "wfp",
            uploadFileDialog: false,
            uploadFileModel: {
                remark: "",
            },
            caseFilesList: [],
            showFile: true,
            fileList: [],
            fileLen: 0,
            fileData: new FormData(),
            fileIdList: [],
            url: "/api/case/czCaseFiles/previewFile/",
            isValidate: false,
            currentFileId: "",
            currentIndex: 0,
            currentFileType: "",
            fileId: "",
            showDoc: false,
            caseList: [],
            CaseInfo: {
                registerCode: "",
                batchId: "",
                defendantName: "",
                plaintiffName: "",
                founder: "",
                caseStatus: [],
                underlyingAmount: "",
                courtName: "",
                agent: "",
                cardNum: "",
                sort: "",
                keyWord: "",
                page: 1,
                limit: 50,
            },
            keyWord: "",
            caseListShow: false,
            page: 1,
            limit: 50,
            total: 50,
            list: [
                {
                    id: "1",
                    fileName: "111",
                },
            ],
            caseIdList: [],
            listLoading: false,
            tableHeight: 610,
        };
    },

    methods: {
        previewFile(id) {
            previewUrl(id).then(res => {
                window.open(res);
            })
        },
        getFileList(id) {
            this.caseFilesList = [];
            getCaseUploadFile(id).then((res) => {
                if (res != [] && res.length > 0) {
                    this.caseFilesList = res;
                }
            });
        },
        downLoad() {
            if (this.fileIdList.length < 1) {
                this.$message.warning("请先选择文件");
                return;
            }
            downLoadFile(
                this,
                {
                    isValidate: false,
                    fileNum: 0,
                    method: "post",
                    url: "/api/case/czCaseFiles/batchDownload",
                },
                (req) => {
                    // var formData = new FormData()
                    //  formData.append("fileId",this.fileIdList);
                    req.data = { fileId: this.fileIdList };
                    return req;
                },
            );
            return;
        },
        handleClick(tab, event) {
            if (tab.name == "wfp") {
                this.status = 1;
                this.isWfp = true;
                this.getFileInfo();
            } else {
                this.status = 2;
                this.isWfp = false;
                this.getFileInfo();
            }
        },
        uploadFileSubmit() {
            this.$refs.upload.submit();
            uploadFile(
                this,
                this.uploadFileModel,
                { url: "/api/case/czCaseFiles/uploadInitFile" },
                (res) => {
                    this.fileList = [];
                    this.FormData = new FormData();
                    this.uploadFileModel.remark = "";
                    this.uploadFileDialog = false;
                },
                this.$refs.upload,
            );
        },
        closeDoc() {
            console.log(1)
            this.showDoc = false;
            this.tableWidth = '100%'
        },
        fileChange(file, fileList) {
            this.fileLen++;
        },
        HttpUploadFile(val) {
            this.fileData.append("fields", val.file);
        },
        getFileUploadUrl() {
            return process.env.VUE_APP_API + "/api/case/czCaseFiles/uploadInitFile";
        },
        showCaseList(fileId) {
            if (fileId == 0 && this.fileIdList.length <= 0) {
                this.$message.warning("请先选择文件");
                return;
            }
            this.currentFileId = fileId;
            this.caseListShow = true;
            this.getCaseList();
        },
        batchDelete(){
            if ( this.fileIdList.length <= 0) {
                this.$message.warning("请先选择文件");
                return;
            }
            this.$confirm("是否确认删除?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then((result) => {
                batchDeleteFile({
                    fileId:this.fileIdList
                }).then(res=>{
                    this.$message.success(res.message);
                    this.getList();
                })
            });
            
        },
        switchDoc(fileId, fileType, index) {
            this.currentIndex = index;
            //判断是否要显示
            this.currentFileId = fileId;
            this.$set(this, "currentFileId", fileId);
            this.$set(this, "currentFileType", fileType);
            this.currentFileType = fileType;
            // this.getFileInfo()

            this.getDoc();
        },
        getCaseList() {
            page(this.CaseInfo).then((res) => {
                this.caseList = res.records;
            });
        },

        bindCase(caseId) {
            if (caseId == 0 && this.caseIdList.length <= 0) {
                this.$message.warning("请先选择案件");
                return;
            }
            let ids;
            this.$confirm("是否选择完毕并绑定所选案件?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then((res) => {
                if (this.fileIdList.length > 0) ids = this.fileIdList;
                else ids = [this.currentFileId];
                bindCase({
                    caseIdList: this.caseIdList.length > 0 ? this.caseIdList : [caseId],
                    fileId: ids,
                }).then((res) => {
                    this.$message.success("绑定成功");
                    this.caseListShow = false;
                    this.getList();
                });
            });
        },
        search() {
            this.getCaseList();
        },
        handleSizeChange(val) {
            this.limit = val;
            this.getList();
        },
        getList() {
            this.getFileInfo();
        },
        getFileInfo() {
            getFileInfo({
                page: this.page,
                limit: this.limit,
                status: this.status,
            }).then((res) => {
                this.list = res.records;
                this.total = res.total;
            });
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        setTableHeight(val) {
            localStorage.setItem("tableHeight", val);
            this.tableHeight = val;
        },

        getDoc() {
            this.showDoc = false;
            setTimeout(() => {
                this.tableWidth = '50%'
                this.showDoc = true;
            }, 100);
        },
        caseHandleSelectionChange(val) {
            let arr = [];
            for (let item of val) {
                arr.push(item.id);
            }

            this.caseIdList = arr;
        },
        handleSelectionChange(val) {
            let arr = [];
            for (let item of val) {
                arr.push(item.id);
            }

            this.fileIdList = arr;
        },
    },
    created() {
        let h = localStorage.getItem("tableHeight");
        if (h != undefined && h != "" && h != null) {
            this.tableHeight = h;
        }
        this.getList();
    },
};
</script>

<style>
.my-tabs .el-tabs__nav {
    width: 100%;
}

.my-tabs #tab-wfp {
    width: 50%;
    text-align: center;
}

.my-tabs #tab-yfp {
    width: 50%;
    text-align: center;
}
</style>